

import React, { useState, useEffect } from 'react';
import AdSense from 'react-adsense';
import { Cookies } from '../../index.js';
import { Outlet, useNavigate, Link } from "react-router-dom";
import { MdTextFields } from 'react-icons/md';
import { FaMicrophone, FaVideo, FaCloudUploadAlt, FaFileAlt } from 'react-icons/fa';
import axios from 'axios';
import Bannerprofile from '../ads/Bannerprofile.jsx';
import { alert_error, alert_success } from "../../AppContext.js";
import { MoonLoader } from "react-spinners";
import { isLocalHost } from '../../shared/host_utils.js';
function Homehust() {
  const navigate = useNavigate();
  const [dalaythongtin, setdalaythongtin] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [apikey, setapikey] = useState('');
  const [category_id, set_category_id] = useState('');
  const [data, setdata] = useState(false);
  function switch_router(link) {
    navigate(link);
  };
  useEffect(() => {
    laythongtin();
  }, []);
  function laythongtin() {
    const myCookieValue = Cookies.get('apikey');
    axios.get('https://hust.media/jop/ecommerce/category.php', {
      params: {
        apikey: myCookieValue,
        domain: 'https://hust.media'
      }
    })
      .then(response => {
        console.log(response.data); // Dữ liệu từ API
        setdata(response.data);
        setdalaythongtin(true);
        // Xử lý dữ liệu ở đây
      })
      .catch(error => {
        alert_error(error);
      });
  };

  const [isExpanded, setIsExpanded] = useState(false);
  const [menuHeight, setMenuHeight] = useState(0);

  const toggleMenu = (value) => {
    set_category_id(value);
    if (!isExpanded) {
      setIsExpanded(!isExpanded);
    }
    else {
      setMenuHeight(0);
      setTimeout(() => {
        setIsExpanded(!isExpanded);
      }, 300);
    }
  };

  useEffect(() => {
    if (isExpanded) {
      // Get the height of the menu content
      const contentHeight = document.getElementById('menu-content').scrollHeight;
      // Set menu height to the height of the content
      setMenuHeight(contentHeight);
    } else {
    }
  }, [isExpanded]);
  return (
    <>
      <div className="mx-2 ">
        {(window.location.hostname == 'hust.media' || isLocalHost(window.location.hostname) || window.location.hostname == 'tecom.pro') &&
          (
            <div className="flex mt-1 max-w-md mx-auto">
              <div className="">
                <Bannerprofile chedo="qualityviews" />
              </div>
              <Link to="/reactapp/baohiem" >
                <button type="button" className="btn-xs w-12 bg-gray-400 rounded-md text-white btn-outline-secondary">Đăng bài bán hàng</button></Link>
            </div>
          )}
        {!dalaythongtin ? (<div className="mt-2 flex justify-center items-center">
          <MoonLoader size={75} color="#003AA5" />{" "}
        </div>
        ) : (<>
          <div className='mx-2 rounded-lg  shadow-xl px-1  max-w-screen-xl mx-auto'>
            <div className="row mt-1 ">
              {data && (<>
                {data.map((item, index) => (
                  <>
                    <div key={index} className="col-xl-4 mt-0">
                      <div className="card mb-3 bg-pink-500 shadow-lg rounded-xl">
                        <div className="grid gap-2">
                          <div className="bg-white border-2  border-white rounded-lg shadow-md ">
                            <div className="bg-green-200">
                              <button onClick={() => toggleMenu(item.category_id)} className="py-2 w-full flex items-center justify-center rounded-full bg-gradient-to-r from-pink-500 to-purple-500 text-white hover:from-pink-600 hover:to-purple-600 hover:text-white text-xl font-semibold shadow-lg focus:outline-none"
                                type="button"
                                id="options-menu"
                                aria-haspopup="true"
                                aria-expanded="true">
                                <img
                                  src={item.category_img}
                                  alt="Placeholder"
                                  className="ml-2 w-6 h-6"
                                />
                                <span className="mx-2 leading-1">{item.category_name}</span>
                              </button>
                              {isExpanded && category_id == item.category_id && (
                                <div className="mx-2 ">
                                  <div className="w-full py-1 justify-center items-center">
                                    <div
                                      className="text-center  overflow-hidden"
                                      style={{
                                        transition: 'height 0.3s ease',
                                        height: menuHeight,
                                      }}
                                    >
                                      <div id="menu-content">
                                        {item.data && (<>
                                          {item.data.map((item, index) => (
                                            <button
                                              onClick={() => switch_router(item.linkurl)}
                                              className="w-full px-2 py-2 bg-white rounded-xl  border-pink-200  border-2 text-gray-700 hover:bg-gray-100"
                                            >
                                              <span className="leading-1">{item.service_name}</span>
                                            </button>
                                          ))} </>)}
                                      </div>
                                    </div>  </div> </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </>))}
              </>)}
              <div className="mx-2">
                <div className="max-w-xs mx-2 mx-auto">
                  <div className="cards">
                    <AdSense.Google
                      client="ca-pub-4574266110812955"
                      slot="3259681051"
                      style={{ display: 'block' }}
                      format="auto"
                      responsive="true"
                    />
                  </div> </div>
              </div>
            </div>
          </div>
        </>)}

      </div>
    </>
  )
}
export default Homehust
